import React from 'react';
import Joyride, { Step, TooltipRenderProps } from 'react-joyride';
import { Box, IconButton, Paper, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

export interface ProductOnboardingProps {
    run: boolean;
    steps: Step[];
    callback?: (data: any) => void;
    getHelpers?: (helpers: any) => void;
}

const CustomTooltip = (props: TooltipRenderProps) => {
    const { closeProps, step, tooltipProps, primaryProps } = props;

    return (
        <Paper
            // variant="standard"
            // severity="info"
            {...tooltipProps}
            // icon={<TipsAndUpdatesIcon sx={{ color: '#EECC52' }} />}
            sx={{
                p: 2,
                // '.MuiAlert-action': {
                //     pl: 0,
                // },
                m: '-1px',
                position: 'relative',
                bgcolor: '#FFF',
                maxWidth: '380px',
            }}
        >
            <Box sx={{ fontWeight: 'bold', mb: 1, color: '#014361' }}>
                {step.title}
            </Box>
            <Box sx={{ fontSize: '14px', lineHeight: 1.2, color: '#014361' }}>
                {step.content}
            </Box>
            <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                sx={{ position: 'absolute', right: 12, top: 12 }}
                onClick={closeProps.onClick}
            >
                <CloseIcon fontSize="inherit" />
            </IconButton>
            <Stack sx={{ pt: 2 }} justifyContent="flex-end" direction="row">
                <Button
                    size="small"
                    {...primaryProps}
                    variant="contained"
                    sx={{ py: 1.5 }}
                >
                    {primaryProps.title}
                </Button>
            </Stack>
        </Paper>
    );
};

export const Onboarding: React.FC<ProductOnboardingProps> = ({
    run,
    steps,
    ...rest
}) => {
    return (
        <Joyride
            {...rest}
            steps={steps}
            continuous
            disableOverlayClose
            spotlightClicks
            tooltipComponent={CustomTooltip}
            run={run}
            locale={{
                last: 'Close',
            }}
            styles={{
                options: {
                    primaryColor: '#55B5CF',
                    zIndex: 1000000,
                },
            }}
        />
    );
};
